import createIcon from '../../createIcon';

/**
 * @component @name Snooze
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNNy44OCAzLjQ2MDE4TDYuNiAxLjkzMDE4TDIgNS43ODAxOEwzLjI5IDcuMzEwMThMNy44OCAzLjQ2MDE4Wk0yMiA1Ljc5MDE4TDE3LjQgMS45MzAxOEwxNi4xMSAzLjQ2MDE4TDIwLjcxIDcuMzIwMThMMjIgNS43OTAxOFpNMTIgNC4wNzAxOEM3LjAzIDQuMDcwMTggMyA4LjEwMDE4IDMgMTMuMDcwMkMzIDE4LjA0MDIgNy4wMiAyMi4wNzAyIDEyIDIyLjA3MDJDMTYuOTcgMjIuMDcwMiAyMSAxOC4wNDAyIDIxIDEzLjA3MDJDMjEgOC4xMDAxOCAxNi45NyA0LjA3MDE4IDEyIDQuMDcwMThaTTEyIDIwLjA3MDJDOC4xMyAyMC4wNzAyIDUgMTYuOTQwMiA1IDEzLjA3MDJDNSA5LjIwMDE4IDguMTMgNi4wNzAxOCAxMiA2LjA3MDE4QzE1Ljg3IDYuMDcwMTggMTkgOS4yMDAxOCAxOSAxMy4wNzAyQzE5IDE2Ljk0MDIgMTUuODcgMjAuMDcwMiAxMiAyMC4wNzAyWk05IDExLjA3MDJIMTIuNjNMOSAxNS4yNzAyVjE3LjA3MDJIMTVWMTUuMDcwMkgxMS4zN0wxNSAxMC44NzAyVjkuMDcwMThIOVYxMS4wNzAyWiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Snooze = createIcon('Snooze', [
  [
    'path',
    {
      d: 'M7.88 3.46018L6.6 1.93018L2 5.78018L3.29 7.31018L7.88 3.46018ZM22 5.79018L17.4 1.93018L16.11 3.46018L20.71 7.32018L22 5.79018ZM12 4.07018C7.03 4.07018 3 8.10018 3 13.0702C3 18.0402 7.02 22.0702 12 22.0702C16.97 22.0702 21 18.0402 21 13.0702C21 8.10018 16.97 4.07018 12 4.07018ZM12 20.0702C8.13 20.0702 5 16.9402 5 13.0702C5 9.20018 8.13 6.07018 12 6.07018C15.87 6.07018 19 9.20018 19 13.0702C19 16.9402 15.87 20.0702 12 20.0702ZM9 11.0702H12.63L9 15.2702V17.0702H15V15.0702H11.37L15 10.8702V9.07018H9V11.0702Z',
      key: 'bdj8z4',
    },
  ],
]);

export default Snooze;
